/**
 * Persist wizard progress for exact resume.
 */

import { saveWizardSessionHint } from './disputeWizardResume';

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/api$/, '').replace(/\/$/, '');

export function saveWizardProgress(metro2Service, roundId, payload, token) {
  if (!roundId || !token || !payload?.current_step) {
    if (payload?.wizard_step && roundId && token) {
      return saveWizardProgress(metro2Service, roundId, {
        current_step: payload.wizard_step,
        wizard_status: payload.wizard_status,
        last_completed_step: payload.last_completed_step,
        package_id: payload.package_id,
        wizard_navigation_state: payload.wizard_navigation_state,
      }, token);
    }
    return;
  }

  const body = {
    current_step: payload.current_step,
    last_completed_step: payload.last_completed_step,
    package_id: payload.package_id,
    generated_letter_ids: payload.generated_letter_ids || [],
    selected_attachment_ids: payload.selected_attachment_ids || [],
    selected_envelope_settings: payload.selected_envelope_settings || {},
    delivery_method: payload.delivery_method,
    wizard_navigation_state: payload.wizard_navigation_state || {},
    wizard_status: payload.wizard_status,
  };

  const saveViaIntelligence = async () => {
    const url = `${API_BASE}/api/dispute-intelligence/rounds/${roundId}/wizard-progress`;
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(url, {
      method: 'PUT',
      headers,
      credentials: 'include',
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  if (metro2Service?.updateWizardProgressFull) {
    metro2Service.updateWizardProgressFull(roundId, body, token).catch((err) => {
      console.warn('[wizard progress] metro2 save failed, trying intelligence API', err);
      saveViaIntelligence().catch((e) => console.warn('[wizard progress] save failed', e));
    });
    return;
  }

  saveViaIntelligence().catch((err) => {
    if (metro2Service?.updateWizardProgress) {
      metro2Service.updateWizardProgress(roundId, {
        wizard_step: body.current_step,
        wizard_status: body.wizard_status,
      }, token).catch((e) => console.warn('[wizard progress] legacy save failed', e));
    } else {
      console.warn('[wizard progress] save failed', err);
    }
  });
}

/** Call when entering or leaving a wizard step. */
export function trackWizardStep({
  metro2Service,
  roundId,
  token,
  currentStep,
  lastCompletedStep,
  packageId,
  navigationState,
  wizardStatus,
  generatedLetterIds,
  selectedAttachmentIds,
  envelopeSettings,
  deliveryMethod,
  family,
  letterCount,
}) {
  saveWizardProgress(metro2Service, roundId, {
    current_step: currentStep,
    last_completed_step: lastCompletedStep,
    package_id: packageId,
    wizard_navigation_state: navigationState,
    wizard_status: wizardStatus,
    generated_letter_ids: generatedLetterIds,
    selected_attachment_ids: selectedAttachmentIds,
    selected_envelope_settings: envelopeSettings,
    delivery_method: deliveryMethod,
  }, token);

  if (roundId && currentStep) {
    saveWizardSessionHint({
      roundId,
      packageId,
      currentStep,
      family,
      letterCount:
        letterCount ??
        navigationState?.letterPackage?.letters?.length ??
        0,
      wizardStatus,
    });
  }
}
